import './lib/apiConfig'; // Initialize API config early
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Use a single origin in development so auth session (localStorage) is shared.
// 127.0.0.1 and localhost are different origins — logging in on one doesn't show on the other.
if (typeof window !== 'undefined' && window.location.hostname === '127.0.0.1') {
  const url =
    window.location.protocol +
    '//localhost' +
    (window.location.port ? ':' + window.location.port : '') +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(url);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
}
